import { render, staticRenderFns } from "./ContractsBox.vue?vue&type=template&id=f918cb9c"
import script from "./ContractsBox.vue?vue&type=script&lang=js"
export * from "./ContractsBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports